import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/videoGallery";
const SERVICE_UPLOAD_NAME = process.env.REACT_APP_API_ENDPOINT;

const generateLinkVideoGalleryById = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/generateLinkVideoGalleryById", payload);
}

const moveFile = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/moveFile", payload);
}

const createFolder = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/createFolder", payload);
}

// const edit = (payload) => {
//     return httpUtils.post(SERVICE_NAME + "/edit", payload);
// }

const edit = (payload) => {
    return httpUtils.postFormData(SERVICE_UPLOAD_NAME + "/videoGallery/edit", payload);
}

const remove = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/delete", payload);
}

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

const add = (formData) => {
    return httpUtils.postFormData(SERVICE_UPLOAD_NAME + "/upload/videoGallery", formData);
}

const videoGalleryApi = {
    generateLinkVideoGalleryById,
    moveFile,
    createFolder,
    edit,
    remove,
    search,
    add
}

export default videoGalleryApi;